import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import clsx from "clsx";
import { useHistory, useParams } from "react-router-dom";
import { useTimezone } from "../../hooks/useTimezone";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import { blue, green, orange, red } from "@material-ui/core/colors";
import { useStyles } from "./TicketListItemCustomStyles";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

import { Tooltip, Menu, MenuItem, ListItemIcon } from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import { getProfilePicUrl } from "../../services/api";
import { sendMessage } from "../../services/messages.api";
import { updateTicket, deleteTicket } from "../../services/tickets.api";
import MarkdownWrapper from "../MarkdownWrapper";

import AndroidIcon from "@material-ui/icons/Android";
import EmojiEmotionsIcon from "@material-ui/icons/EmojiEmotions";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import PeopleIcon from "@material-ui/icons/People";
import ReplayIcon from "@material-ui/icons/Replay";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ChannelIcon from "../ChannelIcon";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ChatIcon from "@material-ui/icons/Chat";
import LockIcon from "@material-ui/icons/Lock";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import AppointmentModal from "../AppointmentModal";
import ConfirmationModal from "../ConfirmationModal";
import { toast } from "react-toastify";
import TicketMessagesDialog from "../TicketMessagesDialog";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import { getInitials } from "../../helpers/getInitials";
import { getContactCountryFlagInfo } from "../../helpers/phoneCountryFlag";
import { generateColor } from "../../helpers/colorGenerator";
import useSettings, { isSettingTruthy } from "../../hooks/useSettings";
import { useSiblingTickets } from "../../context/SiblingTickets/SiblingTicketsContext";
import useUiMode from "../../hooks/useUiMode";
import { LAST_MESSAGE_DELETED_MARKERS } from "../../constants/lastMessage";
import SimpleRow from "./SimpleRow";


const TicketListItemCustom = ({ ticket, status }) => {
  const conHermanos = useSiblingTickets();
  const tieneHermanos = conHermanos.has(ticket?.id);
  const classes = useStyles();
  const theme = useTheme();
  const { getTimeAgo, parseNaiveDate, getNow } = useTimezone(); // ✅ NUEVO: Para acceder al theme en el componente
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState([]);
  const [ticketUser, setTicketUser] = useState(null);
  const [lastInteractionLabel, setLastInteractionLabel] = useState('');
  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);
  const { whatsApps } = useContext(WhatsAppsContext);
  const { profile } = user || {};
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [simpleMenuAnchor, setSimpleMenuAnchor] = useState(null);
  const { isSimple } = useUiMode();
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [closeTicketConfirmOpen, setCloseTicketConfirmOpen] = useState(false);
  const [removeTagsOnCloseEnabled, setRemoveTagsOnCloseEnabled] = useState(false);
  const [sendTicketCloseMessageEnabled, setSendTicketCloseMessageEnabled] =
    useState(false);
  const pendingClosePayloadRef = useRef(null);
  const { getAll } = useSettings();
  const presenceMessage = {
    composing: i18n.t("presence.composing"),
    recording: i18n.t("presence.recording"),
  };

  // ✅ Helper para evitar setState después de unmount (fix warning React)
  const safeSetLoading = (value) => {
    if (isMounted.current) setLoading(value);
  };
  
  // ✅ Obtener estado de WhatsApp desde el contexto (más actualizado)
  const ticketWhatsApp = ticket?.whatsappId 
    ? whatsApps.find(w => w.id === ticket.whatsappId)
    : null;
  const whatsappStatus = ticketWhatsApp?.status || ticket?.whatsapp?.status || "DISCONNECTED";
  const isWhatsAppConnected = whatsappStatus === "CONNECTED";

  const countryFlagInfo = useMemo(
    () => getContactCountryFlagInfo(ticket?.contact, ticket, i18n.language),
    [ticket?.contact, ticket?.contact?.number, ticket?.contact?.isGroup, ticket?.isGroup, i18n.language]
  );

  // ✅ Funciones para manejar el menú desplegable
  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  
  const menuOpen = Boolean(menuAnchorEl);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const list = await getAll();
        const rowTags = list.find((s) => s.key === "removeTagsOnCloseTicket");
        const rowMsg = list.find((s) => s.key === "sendTicketCloseMessage");
        if (!cancelled) {
          setRemoveTagsOnCloseEnabled(
            rowTags ? isSettingTruthy(rowTags.value) : false
          );
          setSendTicketCloseMessageEnabled(
            rowMsg ? isSettingTruthy(rowMsg.value) : false
          );
        }
      } catch (_e) {
        /* noop */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getAll]);

  // Retirado con la miniatura del agente: el escalonado de fotos (0296 Fase C) existía para
  // pedir primero el retrato del contacto y luego el del agente. Sin segunda foto no había
  // ráfaga que escalonar, y quedaba un temporizador de 380 ms más un cambio de estado por
  // cada fila de la lista sin nada que mostrar.
  const contactPortraitImgProps = useMemo(
    () => ({
      loading: "lazy",
      decoding: "async",
    }),
    []
  );

  const executeCloseTicketPutWithToast = async (payload, successMsg) => {
    if (!ticket?.id) return;
    safeSetLoading(true);
    try {
      await updateTicket(ticket.id, payload);
      toast.success(successMsg);
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const needsCloseConfirmModal =
    removeTagsOnCloseEnabled || sendTicketCloseMessageEnabled;

  const getCloseConfirmModalBody = () => {
    const tags = removeTagsOnCloseEnabled;
    const snd = sendTicketCloseMessageEnabled;
    if (tags && snd) {
      return i18n.t("ticketsList.buttons.confirmCloseBodyTagsAndMessage");
    }
    if (tags) {
      return i18n.t("ticketsList.buttons.confirmCloseWithTagsMessage");
    }
    if (snd) {
      return i18n.t("ticketsList.buttons.confirmCloseWithSendMessage");
    }
    return "";
  };

  const requestCloseTicket = (payload, successMsg) => {
    if (needsCloseConfirmModal) {
      pendingClosePayloadRef.current = { payload, successMsg };
      setCloseTicketConfirmOpen(true);
    } else {
      executeCloseTicketPutWithToast(payload, successMsg);
    }
  };

  const handleConfirmCloseTicketModal = () => {
    setCloseTicketConfirmOpen(false);
    const pending = pendingClosePayloadRef.current;
    pendingClosePayloadRef.current = null;
    if (pending?.payload) {
      executeCloseTicketPutWithToast(
        pending.payload,
        pending.successMsg ||
          i18n.t("ticketsList.buttons.ticketClosed") ||
          "Ticket cerrado correctamente"
      );
    }
  };
  
  // ✅ Funciones para las acciones del menú
  const handleResolve = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    requestCloseTicket(
      { status: "closed", userId: user?.id },
      "Ticket resuelto correctamente"
    );
  };

  const handleResolveWithoutFarewell = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    requestCloseTicket(
      { status: "closed", userId: user?.id, sendFarewell: false },
      "Ticket resuelto sin despedida"
    );
  };

  const handleReturn = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await updateTicket(ticket.id, {
        status: "pending",
        userId: null,
      });
      toast.success("Ticket devuelto correctamente");
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleSchedule = () => {
    if (!ticket?.id) return;
    handleMenuClose();
    setScheduleModalOpen(true);
  };

  const handleMarkAsUnread = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await updateTicket(ticket.id, {
        unreadMessages: 1,
      });
      toast.success("Ticket marcado como no leído");
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleKeepWithMe = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await updateTicket(ticket.id, {
        userId: user?.id,
      });
      toast.success("Ticket asignado a ti");
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleDelete = () => {
    if (!ticket?.id) return;
    handleMenuClose();
    setConfirmationOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!ticket?.id) return;
    setConfirmationOpen(false);
    safeSetLoading(true);
    try {
      await deleteTicket(ticket.id);
      toast.success("Ticket eliminado correctamente");
      if (window.location.pathname.includes(`/tickets/${ticket.id}`)) {
        window.location.href = "/tickets";
      }
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  // ✅ FUNCIÓN PARA DETERMINAR QUÉ BOTONES MOSTRAR SEGÚN EL ESTADO DEL GRUPO
  const getGroupTicketButtons = (ticket) => {
    // ✅ ATENDIENDO: Si el ticket tiene estado "open" y tiene usuario asignado, no mostrar transferir ni finalizar
    const isAttending = ticket.status === "open" && ticket.userId;
    
    if (ticket.contact && ticket.contact.isGroup) {
      // ✅ GRUPOS: Botones específicos según estado
      if (ticket.status === "pending") {
        // ✅ PENDIENTE: Solo botón ACEPTAR
        return ["accept"];
      } else if (ticket.status === "open") {
        // ✅ ABIERTO: Si está siendo atendido, sin botones. Si no, mostrar TRANSFERIR y FINALIZAR
        return isAttending ? [] : ["transfer", "finalize"];
      } else if (ticket.status === "closed") {
        // ✅ CERRADO: Botón REABRIR
        return ["reopen"];
      }
    } else {
      // ✅ CONTACTOS INDIVIDUALES: Flujo normal
      if (ticket.status === "pending") {
        return ["accept", "finalize"];
      } else if (ticket.status === "open") {
        // ✅ ABIERTO: Si está siendo atendido, sin botones. Si no, mostrar TRANSFERIR y FINALIZAR
        return isAttending ? [] : ["transfer", "finalize"];
      } else if (ticket.status === "closed") {
        return ["reopen"];
      }
    }
    return [];
  };
  
  useEffect(() => {
    // ✅ CRÍTICO: Inicializar isMounted al montar el componente
    isMounted.current = true;
    
    if (ticket.userId && ticket.user?.name) {
      if (isMounted.current) {
        setTicketUser(ticket.user.name.toUpperCase());
      }
    } else if (!ticket.userId) {
      if (isMounted.current) setTicketUser(null);
    }

    // ✅ CRÍTICO: Actualizar tags siempre que cambien (comparar por contenido, no solo referencia)
    const currentTags = ticket?.tags || [];
    const tagsChanged = JSON.stringify(currentTags) !== JSON.stringify(tag);
    
    if ((tagsChanged || currentTags.length !== tag.length) && isMounted.current) {
      setTag([...currentTags]); // ✅ Crear nueva referencia del array
    }

    // ✅ Cleanup function: Marcar como desmontado
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ticket.presence,
    ticket.tags,
    ticket.updatedAt,
    ticket.id,
    ticket.userId,
    ticket.user?.name,
    ticket.user?.id,
  ]);

  const handleCloseTicket = () => {
    if (!ticket?.id) return;
    // Misma acción que Resolver (check): cierre estándar sin forzar limpieza de integración/cola en el PUT
    requestCloseTicket(
      { status: "closed", userId: user?.id },
      "Ticket resuelto correctamente"
    );
  };

  useEffect(() => {
    isMounted.current = true;

    const updateLabel = () => {
      if (!isMounted.current) return;
      // ✅ Mostrar el badge de tiempo por updatedAt aunque el ticket no tenga lastMessage
      // (tickets "Sin mensaje" también deben mostrar su antigüedad/última actividad)
      if (!ticket.updatedAt) {
        setLastInteractionLabel(null);
        return;
      }
      const { labelText, labelColor } = getTimeAgo(ticket.updatedAt);
      if (!labelText) {
        setLastInteractionLabel(null);
        return;
      }
      setLastInteractionLabel(
        <Typography
          className={classes.lastMessageTime}
          component="span"
          variant="body2"
          style={{
            color: '#ffffff',
            backgroundColor: labelColor || '#6b7280',
            boxShadow: `0 2px 8px ${labelColor || '#6b7280'}40, 0 1px 3px rgba(0, 0, 0, 0.1)`
          }}
        >
          {labelText}
        </Typography>
      );
    };

    updateLabel();
    const id = setInterval(updateLabel, 60_000);

    return () => {
      isMounted.current = false;
      clearInterval(id);
    };
  }, [ticket.updatedAt, getTimeAgo]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleReopenTicket = async (id) => {
    safeSetLoading(true);
    try {
      await updateTicket(id, {
        status: "open",
        userId: user?.id,
        queueId: ticket?.queue?.id
      });
    } catch (err) {
      safeSetLoading(false);
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
    history.push(`/tickets/${ticket.uuid}`);
  };

    // ✅ FUNCIÓN PARA MANEJAR ACEPTAR TICKET DE GRUPO
    const handleAcceptGroupTicket = async (id) => {
      safeSetLoading(true);
      try {
        await updateTicket(id, {
          status: "open",
          userId: user?.id,
        });
        
        // ✅ NO ENVIAR MENSAJE AUTOMÁTICO PARA GRUPOS
        if (!ticket.isGroup) {
          try {
            const list = await getAll();
            const row = list.find((s) => s.key === "sendGreetingAccepted");
            if (row && isSettingTruthy(row.value)) {
              handleSendMessage(ticket.id);
            }
          } catch (err) {
            toastError(err);
          }
        }
      } catch (err) {
        safeSetLoading(false);
        toastError(err);
      } finally {
        safeSetLoading(false);
      }
      history.push(`/tickets/${ticket.uuid}`);
    };

    // ✅ FUNCIÓN NO UTILIZADA - REEMPLAZADA POR handleAcceptGroupTicket
    // const handleAcepptTicket = async (id) => {
    //     setLoading(true);
    //     try {
    //         await api.put(`/tickets/${id}`, {
    //             status: "open",
    //             userId: user?.id,
    //         });
    //         
    //         let settingIndex;

    //         try {
    //             const { data } = await api.get("/settings/");
    //             
    //             settingIndex = data.filter((s) => s.key === "sendGreetingAccepted");
    //             
    //         } catch (err) {
    //             toastError(err);
                   
    //         }
            
    //         if (settingIndex[0].value === "enabled" && !ticket.isGroup) {
    //             handleSendMessage(ticket.id);
                
    //         }

    //     } catch (err) {
    //         setLoading(false);
            
    //         toastError(err);
    //     }
    //     if (isMounted.current) {
    //         setLoading(false);
    //     }

    //     // handleChangeTab(null, "tickets");
    //     // handleChangeTab(null, "open");
    //     history.push(`/tickets/${ticket.uuid}`);
    // };
	
	    const handleSendMessage = async (id) => {
        
        const msg = `{{ms}} *{{name}}*, meu nome é *${user?.name}* e agora vou prosseguir com seu atendimento!`;
        const message = {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `${i18n.t("tickets.automaticMessages.title")}:\n${msg.trim()}`,
        };
        try {
            await sendMessage(id, message);
        } catch (err) {
            toastError(err);
            
        }
    };

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };


  const renderPreviewText = (maxLen) => {
      const lastMessageText = ticket.lastMessage == null ? '' : (typeof ticket.lastMessage === 'string' ? ticket.lastMessage : (ticket.lastMessage.body ?? ''));
      // FIX: Para media sin caption (imagen, video, audio, documento), body puede estar vacío.
      // 1) Usar mediaType de lastMessageWithReactions para etiqueta legible.
      // 2) Si lastMessage es filename (ej: 1773543495802.jpeg), mostrar etiqueta según extensión.
      const lastMsg = ticket.lastMessageWithReactions?.[0];
      const t = (k) => i18n.t(`tickets.preview.${k}`);
      // Último mensaje borrado «para todos»: el backend guarda una marca neutra (doc 0449 §2.4).
      if (LAST_MESSAGE_DELETED_MARKERS.includes(lastMessageText)) {
        return <MarkdownWrapper>{t("deleted")}</MarkdownWrapper>;
      }
      const mediaTypeLabels = {
        image: t("image"), imageMessage: t("image"),
        video: t("video"), videoMessage: t("video"),
        audio: t("audio"), audioMessage: t("audio"), ptt: t("audio"),
        application: t("document"), document: t("document"), documentMessage: t("document"),
        sticker: t("sticker"), stickerMessage: t("sticker"),
        location: t("location"), locationMessage: t("location"),
        contactMessage: t("contact"), vcard: t("contact"),
      };
      // Tipos de sistema/no-contenido: NO usar como preview (ej. "la conversación cambió")
      const systemMediaTypes = ['internal_action', 'reactionMessage', 'notification', 'e2e_notification', 'editedMessage', 'call_log'];
      const lastMsgType = lastMsg?.mediaType;
      let fallbackLabel = (lastMsgType && !systemMediaTypes.includes(lastMsgType))
        ? (mediaTypeLabels[lastMsgType] || null)
        : null;
      if (!fallbackLabel && typeof lastMessageText === 'string' && lastMessageText) {
        const ext = (lastMessageText.split('.').pop() || '').toLowerCase();
        if (['jpg','jpeg','png','gif','webp'].includes(ext)) fallbackLabel = t("image");
        else if (['mp4','webm','mov','avi'].includes(ext)) fallbackLabel = t("video");
        else if (['mp3','ogg','wav','m4a'].includes(ext)) fallbackLabel = t("audio");
        else if (['pdf','doc','docx','xls','xlsx'].includes(ext)) fallbackLabel = t("document");
      }
      // Si lastMessageText es solo un filename (ej: 1773543495802.jpeg), usar etiqueta legible
      const isFilenameOnly = lastMessageText && /^[\w.-]+\.(jpg|jpeg|png|gif|webp|mp4|mp3|pdf|doc|docx)$/i.test(lastMessageText);
      const displayText = lastMessageText && lastMessageText.includes('data:image/png;base64') ? null : 
        (isFilenameOnly && fallbackLabel ? fallbackLabel : (lastMessageText || fallbackLabel || t("none")));
      return lastMessageText && lastMessageText.includes('data:image/png;base64') ? 
        <MarkdownWrapper>{t("location")}</MarkdownWrapper> 
        : 
        <MarkdownWrapper>
          {displayText && displayText.length > maxLen 
            ? `${displayText.substring(0, maxLen)}...` 
            : displayText
          }
        </MarkdownWrapper>;

  };

  const renderTicketInfo = () => {
    return (
      <>
        {/* Icono de chatbot movido a la posición de la fecha/hora */}
      </>
    );
  };

  const handleOpenTransferModal = () => {
    setTransferTicketModalOpen(true);
  }

  const handleCloseTransferTicketModal = () => {
    if (isMounted.current) {
      setTransferTicketModalOpen(false);
    }
  };

  // ✅ FUNCIÓN PARA RENDERIZAR BOTONES DE ACCIÓN SEGÚN EL ESTADO DEL GRUPO
  const renderActionButtons = () => {
    const buttons = getGroupTicketButtons(ticket);
    const isAttending = ticket.status === "open" && ticket.userId;

    const flagBeforeWhatsApp =
      countryFlagInfo && ticket?.whatsapp ? (
        <Tooltip title={countryFlagInfo.countryName} placement="left" arrow>
          <span
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              fontSize: 18,
              lineHeight: 1,
              cursor: "default",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 22,
            }}
            role="img"
            aria-label={countryFlagInfo.countryName}
          >
            {countryFlagInfo.flag}
          </span>
        </Tooltip>
      ) : null;

    /* Aviso de atención duplicada (0424 F3 · CU-5): este contacto tiene otra
       conversación abierta en otro canal y puede estar atendiéndola otra persona.
       Va en LAS DOS ramas —atendiendo y pendiente—: el riesgo de responder cosas
       distintas existe antes de aceptar el ticket, no después. */
    const avisoOtraConversacion = tieneHermanos ? (
      <span style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
        <span
          title="Este contacto tiene otra conversación abierta en otro canal"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          style={{
            display: "inline-flex", alignItems: "center", gap: 3,
            fontSize: 10, lineHeight: 1.6, padding: "0 6px",
            borderRadius: 10, whiteSpace: "nowrap",
            backgroundColor: "#FFF8E1", color: "#8D6E00",
            border: "1px solid #FFE082"
          }}
        >
          ⚠ otra conversación
        </span>
      </span>
    ) : null;

    // Si está siendo atendido: botones arriba, chip de conexión abajo
    if (isAttending) {
      return (
        <>
          {/* Fila 1: botones de acción */}
          <span className={classes.secondaryContentSecond} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {flagBeforeWhatsApp}
            {profile === "admin" && (
              <Tooltip title={i18n.t("ticketsList.spyConversation")}>
                <IconButton
                  size="small"
                  onClick={(e) => { e.stopPropagation(); setOpenTicketMessageDialog(true); }}
                  className={classes.actionIconButton}
                  style={{ color: blue[600], borderColor: blue[200] }}
                >
                  <VisibilityIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Más opciones">
              <IconButton
                size="small"
                onClick={(e) => { e.stopPropagation(); handleMenuOpen(e); }}
                className={classes.actionIconButton}
                style={{ color: "#666", borderColor: "#ddd" }}
              >
                <MoreVertIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </Tooltip>
          </span>
          {avisoOtraConversacion}

          {/* Fila 2: chip de conexión WhatsApp */}
          {ticket?.whatsapp && (
            <span style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
              <span
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                className={`${classes.waConnectionChip} ${isWhatsAppConnected ? classes.waConnectionChipConnected : classes.waConnectionChipDisconnected}`}
              >
                {String(ticket.whatsapp.provider || "").startsWith("telegram")
                  ? <ChannelIcon provider={ticket.whatsapp.provider} size={11} style={{ flexShrink: 0 }} />
                  : <WhatsAppIcon style={{ fontSize: "11px", flexShrink: 0 }} />}
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                  {isWhatsAppConnected
                    ? (ticket.whatsapp.name || "WhatsApp")
                    : `Desc: ${ticket.whatsapp.name || "WhatsApp"}`}
                </span>
              </span>
            </span>
          )}
        </>
      );
    }
    
    // ✅ Botones normales para otros estados
    return (
      <>
        {/* Fila 1: bandera + botones de acción */}
        <span className={classes.secondaryContentSecond}>
          {flagBeforeWhatsApp}
          {buttons.includes("accept") && (
            <Tooltip title={i18n.t("ticketsList.buttons.accept")}>
              <span>
                <IconButton
                  className={`${classes.actionIconButton} ${classes.acceptButton}`}
                  size="small"
                  disabled={loading}
                  onClick={e => handleAcceptGroupTicket(ticket.id)}
                >
                  <CheckIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </span>
            </Tooltip>
          )}

          {buttons.includes("transfer") && (
            <Tooltip title={i18n.t("ticketsList.buttons.transfer")}>
              <span>
                <IconButton
                  className={`${classes.actionIconButton} ${classes.transferButton}`}
                  size="small"
                  disabled={loading}
                  onClick={e => handleOpenTransferModal()}
                >
                  <PeopleIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </span>
            </Tooltip>
          )}

          {buttons.includes("finalize") && (
            <Tooltip title={i18n.t("ticketsList.buttons.closed")}>
              <span>
                <IconButton
                  className={`${classes.actionIconButton} ${classes.closeButton}`}
                  size="small"
                  disabled={loading}
                  onClick={e => handleCloseTicket()}
                >
                  <CloseIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </span>
            </Tooltip>
          )}

          {buttons.includes("reopen") && (
            <Tooltip title={i18n.t("ticketsList.buttons.reopen")}>
              <span>
                <IconButton
                  className={`${classes.actionIconButton} ${classes.reopenButton}`}
                  size="small"
                  disabled={loading}
                  onClick={e => handleReopenTicket(ticket.id)}
                >
                  <ReplayIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {/* Ojo — solo para tickets que NO están en PENDING */}
          {ticket.status !== "pending" && (
            <Tooltip title="Ver conversación">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenTicketMessageDialog(true);
                }}
                className={classes.actionIconButton}
                style={{ color: blue[600], borderColor: blue[200] }}
              >
                <VisibilityIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </Tooltip>
          )}
        </span>
        {avisoOtraConversacion}
        {/* Fila 2: chip de conexión WhatsApp — mismo patrón que isAttending */}
        {ticket?.whatsapp && (
          <span style={{ display: "flex", justifyContent: "flex-end", marginBottom: "4px" }}>
            <span
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              className={`${classes.waConnectionChip} ${isWhatsAppConnected ? classes.waConnectionChipConnected : classes.waConnectionChipDisconnected}`}
            >
              {String(ticket.whatsapp.provider || "").startsWith("telegram")
                  ? <ChannelIcon provider={ticket.whatsapp.provider} size={11} style={{ flexShrink: 0 }} />
                  : <WhatsAppIcon style={{ fontSize: "11px", flexShrink: 0 }} />}
              <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                {isWhatsAppConnected
                  ? (ticket.whatsapp.name || "WhatsApp")
                  : `Desc: ${ticket.whatsapp.name || "WhatsApp"}`}
              </span>
            </span>
          </span>
        )}
      </>
    );
  };

  // ✅ Validación: si no hay ticket, no renderizar nada (después de todos los hooks)
  if (!ticket || !ticket.id) {
    return null;
  }

  // Modo simple (doc 0446): mismos datos y manejadores, otra presentación.
  const canUseMainMenu =
    ticket.status === "open" && ticket.userId && (ticket.userId === user?.id || profile === "admin");
  const simpleMenuButtons = isSimple ? getGroupTicketButtons(ticket) : [];
  const contactPicSrc =
    ticket?.contact?.profilePicUrl && !ticket.contact.profilePicUrl.includes("nopicture.png")
      ? getProfilePicUrl(ticket.contact.profilePicUrl)
      : null;
  let simpleTimeText = "";
  if (isSimple && ticket.updatedAt) {
    const m = parseNaiveDate(ticket.updatedAt);
    if (m && m.isValid()) {
      const now = getNow();
      if (m.isSame(now, "day")) simpleTimeText = m.format("HH:mm");
      else if (m.isSame(now.clone().subtract(1, "day"), "day")) simpleTimeText = i18n.t("tickets.simple.yesterday");
      else simpleTimeText = m.format("DD/MM/YY");
    }
  }

  return (
    <React.Fragment key={ticket.id}>

    <TransferTicketModalCustom
    modalOpen={transferTicketModalOpen}
    onClose={handleCloseTransferTicketModal}
    ticketid={ticket.id}
  />

      <TicketMessagesDialog
        open={openTicketMessageDialog}

        handleClose={() => setOpenTicketMessageDialog(false)}
        ticketId={ticket.id}
      ></TicketMessagesDialog>
      {isSimple ? (
        <SimpleRow
          selected={Boolean(ticketId && +ticketId === ticket.id)}
          onOpen={(e) => {
            if (ticket.status === "pending") {
              e.stopPropagation();
              setOpenTicketMessageDialog(true);
              return;
            }
            handleSelectTicket(ticket);
          }}
          avatar={
            <Avatar
              imgProps={contactPortraitImgProps}
              style={{ width: 48, height: 48, backgroundColor: generateColor(ticket?.contact?.number) }}
              src={contactPicSrc}
              onError={(e) => {
                if (e.target) e.target.style.display = "none";
              }}
            >
              {getInitials(ticket?.contact?.name || "")}
            </Avatar>
          }
          provider={ticket?.whatsapp?.provider}
          name={ticket?.contact?.name || "Contacto sin nombre"}
          timeText={simpleTimeText}
          preview={renderPreviewText(80)}
          presenceText={
            ["composing", "recording"].includes(ticket?.presence) ? presenceMessage[ticket.presence] : null
          }
          unread={ticketId === String(ticket.id) ? 0 : ticket.unreadMessages || 0}
          isPending={ticket.status === "pending"}
          hasSiblings={tieneHermanos}
          loading={loading}
          onAccept={() => handleAcceptGroupTicket(ticket.id)}
          acceptLabel={i18n.t("ticketsList.buttons.accept")}
          onOpenActions={(e) => {
            if (canUseMainMenu) {
              setMenuAnchorEl(e.currentTarget);
            } else {
              setSimpleMenuAnchor(e.currentTarget);
            }
          }}
        />
      ) : (
      <>
      <ListItem dense button
        onClick={(e) => {
          // ✅ CORRECCIÓN 2025-12-23: Si el ticket está en PENDING, abrir en modo lectura
          if (ticket.status === "pending") {
            e.stopPropagation();
            setOpenTicketMessageDialog(true);
            return;
          }
          handleSelectTicket(ticket);
        }}
        selected={ticketId && +ticketId === ticket.id}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === "pending",
        })}
      >
        <Tooltip arrow placement="right" title={ticket.queue?.name?.toUpperCase() || ""} >
          <span style={{ backgroundColor: ticket.queue?.color || "#7C7C7C" }} className={classes.ticketQueueColor}></span>
        </Tooltip>
        <ListItemAvatar>
          <Box display="flex" flexDirection="column" alignItems="center" style={{ marginRight: 8, position: "relative" }}> {/* ✅ REDUCIDO: De 12px a 8px, agregado position relative */}
            <Box className={classes.avatarContainer} style={{ position: "relative" }}>
          {ticket.status !== "pending" ?
            <Avatar
              key={`avatar-${ticket.id}-${ticket?.contact?.id}-${ticket?.contact?.profilePicUrl || 'no-pic'}-${ticket?.contact?.updatedAt || ''}`}
                  className={classes.avatarActive}
              imgProps={contactPortraitImgProps}
              style={{
                backgroundColor: generateColor(ticket?.contact?.number),
              }}
              src={(ticket?.contact?.profilePicUrl && 
                     ticket.contact.profilePicUrl !== "" && 
                     !ticket.contact.profilePicUrl.includes("nopicture.png")) 
                     ? getProfilePicUrl(ticket.contact.profilePicUrl) 
                     : null}
              onError={(e) => {
                // ✅ FIX 05/12/2025: Si la imagen falla al cargar, ocultar para mostrar iniciales
                if (e.target) {
                  e.target.style.display = 'none';
                }
              }}>
              {getInitials(ticket?.contact?.name || "")}
              </Avatar>
            :
            <Avatar
              key={`avatar-${ticket.id}-${ticket?.contact?.id}-${ticket?.contact?.profilePicUrl || 'no-pic'}-${ticket?.contact?.updatedAt || ''}`}
                  className={classes.avatarPending}
              imgProps={contactPortraitImgProps}
              style={{
                backgroundColor: generateColor(ticket?.contact?.number),
              }}
              src={(ticket?.contact?.profilePicUrl && 
                     ticket.contact.profilePicUrl !== "" && 
                     !ticket.contact.profilePicUrl.includes("nopicture.png")) 
                     ? getProfilePicUrl(ticket.contact.profilePicUrl) 
                     : null}
              onError={(e) => {
                // ✅ FIX 05/12/2025: Si la imagen falla al cargar, ocultar para mostrar iniciales
                if (e.target) {
                  e.target.style.display = 'none';
                }
              }}>
              {getInitials(ticket?.contact?.name || "")}
              </Avatar>
          }
              {/* Canal de entrada del ticket. Permanente: todo ticket cuelga de una
                  conexión, y el logo la identifica sin depender del nombre que el cliente
                  le haya puesto ("WABA LHV", "FB Leopoldo Saas").

                  Ocupa el hueco que dejó la miniatura del agente: esa insignia repetía el
                  dato que ya se lee en letra justo debajo del avatar. */}
              <Box className={classes.channelAvatarBadge}>
                <ChannelIcon provider={ticket?.whatsapp?.provider} size={20} />
              </Box>
            </Box>
            {/* M3: bajo avatar — con asignado: nombre + #ticket; sin asignado: solo #ticket (coherente con TicketInfo `#{ticket.id}`) */}
            <Box className={classes.avatarMetaBelow}>
              {(ticket.userId || ticket.user) &&
                (ticket.user?.name || ticketUser) && (
                  <Typography
                    component="span"
                    variant="caption"
                    className={classes.avatarMetaAssignee}
                    title={ticket.user?.name || ticketUser || ""}
                  >
                    {ticket.user?.name || ticketUser || ""}
                  </Typography>
                )}
              <Typography
                component="span"
                variant="caption"
                className={classes.avatarMetaTicketId}
              >
                #{ticket.id}
              </Typography>
            </Box>
          </Box>
        </ListItemAvatar>
        <ListItemText
          disableTypography

          primary={
            <span className={classes.contactNameWrapper}>
            <Typography
            noWrap
            component='span'
            variant='body2'
            color='textPrimary'
          >
            <strong>{ticket?.contact?.name || 'Contacto sin nombre'}</strong>
        <ListItemSecondaryAction>
          <Box className={classes.ticketInfo1}>{renderTicketInfo()}</Box>
        </ListItemSecondaryAction>
              </Typography>
        </span>

          }
          secondary={
            <span className={classes.contactNameWrapper}>

              <Typography
                className={classes.contactLastMessage}
                noWrap
                component="span"
                variant="body2"
                color="textSecondary"
              >
                {["composing", "recording"].includes(ticket?.presence) ? (
                  <span className={classes.presence}>
                    {presenceMessage[ticket.presence]}
                  </span>
                ) : (
                  <>
                    {renderPreviewText(30)}
                    
                    {/* ✅ MOSTRAR REACCIONES DEL ÚLTIMO MENSAJE EN LA VISTA PREVIA */}
                    {ticket.lastMessageWithReactions && ticket.lastMessageWithReactions.length > 0 && (
                      <span style={{
                        marginLeft: '8px',
                        fontSize: '14px',
                        display: 'inline-block'
                      }}>
                        {ticket.lastMessageWithReactions[0].reactions && ticket.lastMessageWithReactions[0].reactions.length > 0 && (
                          <span style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '12px',
                            padding: '2px 6px',
                            fontSize: '12px',
                            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                          }}>
                            {ticket.lastMessageWithReactions[0].reactions[ticket.lastMessageWithReactions[0].reactions.length - 1].type}
                          </span>
                        )}
                      </span>
                    )}
                  </>
                )}

                <span style={{ marginTop: 2 }} className={classes.secondaryContentSecond} > {/* ✅ REDUCIDO: marginTop de 4px a 2px */}
                  {ticket.queue?.name && <Badge style={{ backgroundColor: ticket.queue?.color || "#7c7c7c" }} className={classes.connectionTag}>{ticket.queue?.name?.toUpperCase()}</Badge>}
                  {/* ✅ INDICADORES DE AGENTE IA */}
                  {ticket.chatbot && (
                    <Tooltip title="🤖 Agente IA - Chatbot activo">
                      <AndroidIcon
                        fontSize="small"
                        style={{ 
                          color: blue[600], 
                          fontSize: '16px',
                          marginLeft: '5px',
                          marginTop: '2px',
                          cursor: 'pointer'
                        }}
                      />
                    </Tooltip>
                  )}
                  
                  					{/* ✅ INDICADOR DE PROMPT IA */}
					{ticket.promptId && (
						<Tooltip title="🧠 IA Inteligente - Prompt configurado">
							<EmojiEmotionsIcon
								fontSize="small"
								style={{ 
									color: green[600], 
									fontSize: '16px',
									marginLeft: '5px',
									marginTop: '2px',
									cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
                  
                  					{/* ✅ INDICADOR DE INTEGRACIÓN */}
					{ticket.useIntegration && (
						<Tooltip title="🔗 Integración Externa - N8N/Dialogflow">
							<SettingsIcon
								fontSize="small"
								style={{ 
									color: orange[600], 
									fontSize: '16px',
									marginLeft: '5px',
									marginTop: '2px',
									cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
                  
                  					{/* ✅ INDICADOR DE FLOWBUILDER */}
					{/* ✅ CRÍTICO: Solo mostrar icono de FlowBuilder en pestaña "ai" */}
					{status === "ai" && (ticket.flowStatus != null || ticket.queue?.flowBuilderId) && (
						<Tooltip title="🌊 FlowBuilder - Automatización de flujos activa">
							<AccountTreeIcon
								fontSize="small"
								style={{ 
									color: green[700], 
									fontSize: '16px',
									marginLeft: '5px',
									marginTop: '2px',
									cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
                </span>


                {/*<span style={{ marginTop: 4, fontSize: 5 }} className={classes.secondaryContentSecond} >
                  {ticketUser ? <Chip size="small" icon={<FaceIcon />} label={ticketUser} variant="outlined" /> : <br></br>}
                </span>*/}

                <span
                  style={{
                    paddingTop: "1px",
                    marginTop: "2px",
                    display: "inline-flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "2px",
                    maxWidth: "100%",
                  }}
                  className={classes.secondaryContentSecond}
                >
                  {Array.isArray(tag) &&
                    tag.length > 0 &&
                    tag.map((t) => (
                      <Tooltip key={t.id != null ? `tag-${t.id}` : `tag-${t.name}-${t.color}`} title={t.name || ""} placement="top" arrow>
                        <span style={{ display: "inline-flex", alignItems: "center", lineHeight: 0 }}>
                          <LocalOfferIcon
                            fontSize="small"
                            style={{
                              color: t.color || "#9e9e9e",
                              fontSize: "16px",
                              marginTop: "2px",
                              cursor: "default",
                              verticalAlign: "middle",
                            }}
                            aria-label={t.name || "tag"}
                          />
                        </span>
                      </Tooltip>
                    ))}
                </span>

              </Typography>
            </span>
          }

        />
        {/* ✅ TIEMPO RELATIVO DEL TICKET - Reposicionado más cerca de los botones */}
        <ListItemSecondaryAction style={{ 
          marginTop: ticket.lastMessage ? '8px' : '0', // ✅ REDUCIDO: De 32px a 8px - Más cerca del contenido
          marginBottom: '8px', // ✅ REDUCIDO: De 16px a 8px
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'flex-end',
          gap: '4px', // ✅ NUEVO: Espacio entre badge de tiempo y botones
          right: '4px', // ✅ NUEVO: Mover botones más hacia la derecha, cerca del borde del ticket
          paddingRight: '0px' // ✅ NUEVO: Eliminar padding derecho para acercar más al borde
        }}>
          {/* Badge tiempo + contador mensajes no leídos en la misma fila */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            {ticket.unreadMessages > 0 && ticketId !== String(ticket.id) && (
              <div style={{
                minWidth: 20,
                height: 20,
                padding: "0 5px",
                borderRadius: 10,
                backgroundColor: "#25d366",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "bold",
                boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                boxSizing: "border-box",
                lineHeight: 1,
              }}>
                {ticket.unreadMessages > 99 ? "99+" : ticket.unreadMessages}
              </div>
            )}
            {lastInteractionLabel}
          </div>
          {renderActionButtons()}
        </ListItemSecondaryAction>

      
      </ListItem>

      <Divider variant="inset" component="li" />
      </>
      )}

      {/* ✅ MENÚ DESPLEGABLE CON OPCIONES - Solo cuando está siendo atendido */}
      {ticket.status === "open" && ticket.userId && (ticket.userId === user?.id || user?.profile === "admin") && (
        <Menu
          anchorEl={menuAnchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
        >
          {isSimple && profile === "admin" && (
            <MenuItem onClick={() => { handleMenuClose(); setOpenTicketMessageDialog(true); }}>
              <ListItemIcon>
                <VisibilityIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("tickets.simple.viewConversation")} />
            </MenuItem>
          )}
          <MenuItem onClick={handleResolve}>
            <ListItemIcon>
              <CheckCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Resolver" />
          </MenuItem>
          <MenuItem onClick={handleResolveWithoutFarewell}>
            <ListItemIcon>
              <CheckCircleOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Resolver sin despedida" />
          </MenuItem>
          <MenuItem onClick={handleReturn}>
            <ListItemIcon>
              <ArrowBackIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Devolver" />
          </MenuItem>
          <MenuItem onClick={() => {
            handleMenuClose();
            handleOpenTransferModal();
          }}>
            <ListItemIcon>
              <PeopleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={i18n.t("ticketsList.buttons.transfer")} />
          </MenuItem>
          <MenuItem onClick={handleSchedule}>
            <ListItemIcon>
              <ScheduleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Posponer" />
          </MenuItem>
          <MenuItem onClick={handleMarkAsUnread}>
            <ListItemIcon>
              <ChatIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Marcar como no leído" />
          </MenuItem>
          <MenuItem onClick={handleKeepWithMe}>
            <ListItemIcon>
              <LockIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Mantener conmigo" />
          </MenuItem>
          {/* ✅ Solo mostrar opción "Eliminar" para administradores */}
          {user?.profile === 'admin' && (
          <MenuItem onClick={handleDelete}>
            <ListItemIcon>
              <CloseIcon fontSize="small" style={{ color: red[500] }} />
            </ListItemIcon>
            <ListItemText primary="Eliminar" primaryTypographyProps={{ style: { color: red[500] } }} />
          </MenuItem>
          )}
        </Menu>
      )}

      {isSimple && (
        <Menu
          anchorEl={simpleMenuAnchor}
          open={Boolean(simpleMenuAnchor)}
          onClose={() => setSimpleMenuAnchor(null)}
        >
          {simpleMenuButtons.includes("accept") && (
            <MenuItem onClick={() => { setSimpleMenuAnchor(null); handleAcceptGroupTicket(ticket.id); }}>
              <ListItemIcon><CheckIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary={i18n.t("ticketsList.buttons.accept")} />
            </MenuItem>
          )}
          {simpleMenuButtons.includes("transfer") && (
            <MenuItem onClick={() => { setSimpleMenuAnchor(null); handleOpenTransferModal(); }}>
              <ListItemIcon><PeopleIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary={i18n.t("ticketsList.buttons.transfer")} />
            </MenuItem>
          )}
          {simpleMenuButtons.includes("finalize") && (
            <MenuItem onClick={() => { setSimpleMenuAnchor(null); handleCloseTicket(); }}>
              <ListItemIcon><CheckCircleIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary={i18n.t("ticketsList.buttons.closed")} />
            </MenuItem>
          )}
          {simpleMenuButtons.includes("reopen") && (
            <MenuItem onClick={() => { setSimpleMenuAnchor(null); handleReopenTicket(ticket.id); }}>
              <ListItemIcon><ReplayIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary={i18n.t("ticketsList.buttons.reopen")} />
            </MenuItem>
          )}
          {ticket.status !== "pending" && (
            <MenuItem onClick={() => { setSimpleMenuAnchor(null); setOpenTicketMessageDialog(true); }}>
              <ListItemIcon><VisibilityIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary={i18n.t("tickets.simple.viewConversation")} />
            </MenuItem>
          )}
        </Menu>
      )}
      
      {/* ✅ MODALES */}
      <AppointmentModal
        open={scheduleModalOpen}
        onClose={() => {
          setScheduleModalOpen(false);
        }}
        appointment={null}
        ticketId={ticket.id}
        initialWhatsappId={ticket.whatsappId}
        initialContact={ticket.contact}
        onSaved={() => {}}
      />
      <ConfirmationModal
        title={`¿Eliminar ticket #${ticket.id} de ${ticket.contact?.name || "contacto desconocido"}?`}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={handleConfirmDelete}
      >
        Esta acción no se puede deshacer.
      </ConfirmationModal>
      <ConfirmationModal
        title={i18n.t("ticketsList.buttons.confirmCloseWithTagsTitle")}
        open={closeTicketConfirmOpen}
        onClose={() => {
          setCloseTicketConfirmOpen(false);
          pendingClosePayloadRef.current = null;
        }}
        onConfirm={handleConfirmCloseTicketModal}
      >
        {getCloseConfirmModalBody()}
      </ConfirmationModal>
    </React.Fragment>
  );
};

// ✅ MEMOIZACIÓN: Solo re-renderizar si cambian propiedades relevantes
const MemoizedTicketListItemCustom = React.memo(TicketListItemCustom, (prevProps, nextProps) => {
  const tagsSig = (tik) =>
    JSON.stringify((tik?.tags || []).map((x) => [x?.id, x?.name, x?.color]));
  return (
    prevProps.ticket.id === nextProps.ticket.id &&
    prevProps.ticket.status === nextProps.ticket.status &&
    prevProps.ticket.updatedAt === nextProps.ticket.updatedAt &&
    prevProps.ticket.unreadMessages === nextProps.ticket.unreadMessages &&
    prevProps.ticket.userId === nextProps.ticket.userId &&
    prevProps.ticket.user?.name === nextProps.ticket.user?.name &&
    prevProps.ticket.presence === nextProps.ticket.presence &&
    prevProps.ticket.lastMessage?.id === nextProps.ticket.lastMessage?.id &&
    tagsSig(prevProps.ticket) === tagsSig(nextProps.ticket)
  );
});

MemoizedTicketListItemCustom.displayName = 'TicketListItemCustom';

export default MemoizedTicketListItemCustom;
